import { IFormItemValidation, TFormFieldLayout } from '../../types/layout/form';
import {
    IFormItemValidationResult,
    TClearFormsState,
    TDeleteFormState,
    TFormFieldValue,
    TFormStateMode,
    TFormValues,
    TInitFormState,
    TPushFormFieldTitle,
    TPushFormFieldValidation,
    TPushFormFieldValidationResult,
    TResetFormItemValidationResult,
    TResetFormValidationResults,
    TSetFormFieldData,
    TSetFormFieldInitialValue,
    TSetFormFieldLayout,
    TSetFormFieldMessage,
    TSetFormFieldValue,
    TSetFormInitialValues,
    TSetFormStateMode,
} from '../../types/redux/forms';

export const FORM_INIT_STATE = 'FORM_INIT_STATE';
export const FORM_CLEAR_STATE = 'FORM_CLEAR_STATE';
export const FORM_SET_FIELD_VALUE = 'FORM_SET_FIELD_VALUE';
export const FORM_SET_FIELD_INITIAL_VALUE = 'FORM_SET_FIELD_INITIAL_VALUE';
export const FORM_SET_INITIAL_VALUES = 'FORM_SET_INITIAL_VALUES';
export const FORM_STATE_SET_MODE = 'FORM_STATE_SET_MODE';
export const FORM_PUSH_FIELD_VALIDATION = 'FORM_PUSH_FIELD_VALIDATION';
export const FORM_PUSH_FIELD_VALIDATION_RESULT = 'FORM_PUSH_FIELD_VALIDATION_RESULT';
export const FORM_RESET_VALIDATION_RESULTS = 'FORM_RESET_VALIDATION_RESULTS';
export const FORM_PUSH_FIELD_TITLE = 'FORM_PUSH_FIELD_TITLE';
export const FORM_ITEM_RESET_VALIDATION_RESULT = 'FORM_ITEM_RESET_VALIDATION_RESULT';
export const FORM_DELETE_STATE = 'FORM_DELETE_STATE';
export const FORM_SET_FIELD_MESSAGE = 'FORM_SET_FIELD_MESSAGE';
export const FORM_SET_FIELD_LAYOUT = 'FORM_SET_FIELD_LAYOUT';
export const FORM_SET_FIELD_DATA = 'FORM_SET_FIELD_DATA';

export const initFormState = (layoutId: string): TInitFormState => ({
    type: FORM_INIT_STATE,
    layoutId,
});

export const setFormFieldValue = (
    layoutId: string,
    fieldName: string,
    value: TFormFieldValue,
): TSetFormFieldValue => ({
    type: FORM_SET_FIELD_VALUE,
    payload: {
        fieldName,
        value,
    },
    layoutId,
});

export const setFormFieldInitialValue = (
    layoutId: string,
    fieldName: string,
    value: TFormFieldValue,
): TSetFormFieldInitialValue => ({
    type: FORM_SET_FIELD_INITIAL_VALUE,
    payload: {
        fieldName,
        value,
    },
    layoutId,
});

export const setFormInitialValues = (
    layoutId: string,
    initialValues: TFormValues,
): TSetFormInitialValues => ({
    type: FORM_SET_INITIAL_VALUES,
    payload: {
        initialValues,
    },
    layoutId,
});

export const clearFormState = (layoutId: string): TClearFormsState => ({
    type: FORM_CLEAR_STATE,
    layoutId,
});

export const deleteFormState = (layoutId: string): TDeleteFormState => ({
    type: FORM_DELETE_STATE,
    layoutId,
});

export const setFormStateMode = (
    layoutId: string,
    mode: TFormStateMode,
): TSetFormStateMode => ({
    type: FORM_STATE_SET_MODE,
    payload: {
        mode,
    },
    layoutId,
});

export const pushFormFieldValidation = (
    layoutId: string,
    fieldName: string,
    validation: IFormItemValidation,
): TPushFormFieldValidation => ({
    type: FORM_PUSH_FIELD_VALIDATION,
    payload: {
        fieldName,
        validation,
    },
    layoutId,
});

export const pushFormFieldValidationResult = (
    layoutId: string,
    fieldName: string,
    result: IFormItemValidationResult,
): TPushFormFieldValidationResult => ({
    type: FORM_PUSH_FIELD_VALIDATION_RESULT,
    payload: {
        fieldName,
        result,
    },
    layoutId,
});

export const resetFormValidationResults = (
    layoutId: string,
): TResetFormValidationResults => ({
    type: FORM_RESET_VALIDATION_RESULTS,
    layoutId,
});

export const pushFormFieldTitle = (
    layoutId: string,
    fieldName: string,
    title: string,
): TPushFormFieldTitle => ({
    type: FORM_PUSH_FIELD_TITLE,
    payload: {
        fieldName,
        title,
    },
    layoutId,
});

export const resetFormItemValidationResult = (
    layoutId: string,
    fieldName: string,
): TResetFormItemValidationResult => ({
    type: FORM_ITEM_RESET_VALIDATION_RESULT,
    payload: {
        fieldName,
    },
    layoutId,
});

export const setFormFieldMessage = (
    layoutId: string,
    fieldName: string,
    message: string,
    className?: string,
): TSetFormFieldMessage => ({
    type: FORM_SET_FIELD_MESSAGE,
    payload: {
        className,
        fieldName,
        message,
    },
    layoutId,
});

export const setFormFieldLayout = (
    layoutId: string,
    fieldName: string,
    layout: TFormFieldLayout,
): TSetFormFieldLayout => ({
    type: FORM_SET_FIELD_LAYOUT,
    layoutId,
    payload: {
        fieldName,
        layout,
    },
});

export const setFormFieldData = (
    layoutId: string,
    fieldName: string,
    data: any,
): TSetFormFieldData => ({
    type: FORM_SET_FIELD_DATA,
    layoutId,
    payload: {
        fieldName,
        data,
    },
});
